import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const RootWrapper = styled(Box)({
  display: "flex",
  flexDirection: "row",
});

export const SidebarWrapper = styled(Box)(({ theme }) => ({
  display: "none",
  [theme.breakpoints.up("lg")]: {
    display: "block",
  },
}));

export const ContentWrapper = styled(Box)({
  width: "100%",
});

export const DragOverlayBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isDefaultTheme",
})(({ theme, isDefaultTheme }) => ({
  padding: theme.spacing(1),
  backgroundColor: isDefaultTheme
    ? "rgba(73,42,24, 0.25)"
    : "rgba(255,255,255, 0.05)",
  border: `2px solid ${theme.palette.text.primary}`,
  borderRadius: "8px",
}));

export const DragOverlayText = styled(Typography)(({ theme }) => ({
  fontFamily: "'Gotham', sans-serif",
  fontSize: "12px",
  color: theme.palette.text.primary,
}));
